(function() {
  var initializedAttribute = 'data-product-addons-initialized';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getProductForm(container) {
    var formId = container.getAttribute('data-product-form-id');
    if (formId) {
      return document.getElementById(formId);
    }
    return null;
  }

  function getRelatedInput(container, name) {
    var form = getProductForm(container);
    var formId = container.getAttribute('data-product-form-id');
    var input = form && form.querySelector('[name="' + name + '"]');
    if (input) return input;

    if (formId) {
      input = toArray(document.querySelectorAll('[name="' + name + '"]')).filter(function(candidate) {
        return candidate.getAttribute('form') === formId;
      })[0];
      if (input) return input;
    }

    return document.querySelector('[name="' + name + '"]');
  }

  function getMainVariantId(container) {
    var input = getRelatedInput(container, 'id');
    var variantId = input && input.value ? input.value : container.getAttribute('data-current-variant-id');
    return /^\d{1,20}$/.test(String(variantId || '')) ? String(variantId) : '';
  }

  function getQuantity(container) {
    var input = getRelatedInput(container, 'quantity');
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity > 0 ? quantity : 1;
  }

  function getMainPrice(container) {
    return parseInt(container.getAttribute('data-current-variant-price'), 10) || 0;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getCheckedAddons(container) {
    return toArray(container.querySelectorAll('.product-addons__checkbox:checked')).map(function(checkbox) {
      return {
        checkbox: checkbox,
        variantId: checkbox.getAttribute('data-variant-id'),
        price: parseInt(checkbox.getAttribute('data-price'), 10) || 0
      };
    }).filter(function(addon) {
      return /^\d{1,20}$/.test(String(addon.variantId || ''));
    });
  }

  function updateCardState(checkbox) {
    var card = checkbox.closest('.product-addons__card');
    if (!card) return;
    card.classList.toggle('product-addons__card--selected', checkbox.checked);
  }

  function updateSubtotal(container) {
    var target = container.querySelector('[data-product-addons-subtotal-price]');
    if (!target) return;
    var checkedAddons = getCheckedAddons(container);
    var subtotalContainer = container.querySelector('[data-product-addons-subtotal]');
    if (subtotalContainer) {
      subtotalContainer.hidden = checkedAddons.length === 0;
    }
    var subtotal = getMainPrice(container) * getQuantity(container);
    subtotal += checkedAddons.reduce(function(sum, addon) {
      return sum + addon.price;
    }, 0);
    target.textContent = formatMoney(subtotal);
  }

  function updateButtonVisibility(container) {
    var button = container.querySelector('[data-product-addons-atc]');
    if (!button) return;
    button.hidden = getCheckedAddons(container).length === 0;
  }

  function setError(container, message) {
    var target = container.querySelector('.product-addons__error, [data-product-addons-error]');
    if (!target) return;
    target.textContent = message || '';
    target.hidden = !message;
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    if (!button.dataset.defaultText) {
      button.dataset.defaultText = button.textContent;
    }
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.textContent = isLoading ? 'Adding...' : button.dataset.defaultText;
  }

  function parseCartResponse(response) {
    if (response.ok) {
      return response.json();
    }
    return response.json().catch(function() {
      return {};
    }).then(function(body) {
      var error = new Error(body.description || body.message || 'Add to cart failed. Please try again.');
      error.response = response;
      throw error;
    });
  }

  function openCart() {
    if (window.ajaxCart && ajaxCart.load) {
      ajaxCart.load();
    }
    document.body.classList.add('shopping');
  }

  function productFormControls(container) {
    var form = getProductForm(container);
    var formId = container.getAttribute('data-product-form-id');
    var controls = form ? toArray(form.querySelectorAll('input, select, textarea')) : [];

    if (formId) {
      toArray(document.querySelectorAll('[form="' + formId + '"]')).forEach(function(control) {
        if (controls.indexOf(control) === -1) {
          controls.push(control);
        }
      });
    }

    return controls;
  }

  function appendMainProductFormFields(container, item) {
    productFormControls(container).forEach(function(control) {
      var name = control.getAttribute('name');
      if (!name || control.disabled || name === 'id' || name === 'quantity') return;
      if ((control.getAttribute('type') === 'checkbox' || control.getAttribute('type') === 'radio') && !control.checked) return;

      if (name === 'selling_plan') {
        if (control.value) item.selling_plan = control.value;
        return;
      }

      var propertyMatch = name.match(/^properties\[(.+)\]$/);
      if (propertyMatch) {
        item.properties = item.properties || {};
        item.properties[propertyMatch[1]] = control.value;
      }
    });
  }

  function buildItems(container) {
    var mainVariantId = getMainVariantId(container);
    var quantity = getQuantity(container);
    if (!mainVariantId) return [];
    var items = [{ id: mainVariantId, quantity: quantity }];
    appendMainProductFormFields(container, items[0]);
    getCheckedAddons(container).forEach(function(addon) {
      items.push({
        id: addon.variantId,
        quantity: 1,
        properties: {
          _source: 'addon',
          _addon_source_variant_id: mainVariantId,
          _attribution_version: '1'
        }
      });
    });
    return items;
  }

  function handleAdd(container, button) {
    var items = buildItems(container);
    if (!getCheckedAddons(container).length) {
      setError(container, 'Choose an add-on before adding.');
      updateButtonVisibility(container);
      return;
    }
    if (!items.length) {
      setError(container, 'Please select a product option before adding to cart.');
      return;
    }

    setError(container, '');
    setButtonLoading(button, true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(parseCartResponse).then(function() {
      openCart();
    }).catch(function(error) {
      setError(container, error.message || 'Add to cart failed. Please try again.');
    }).then(function() {
      setButtonLoading(button, false);
    });
  }

  function init(container) {
    if (!container || container.hasAttribute(initializedAttribute)) return;
    container.setAttribute(initializedAttribute, 'true');

    var checkboxes = toArray(container.querySelectorAll('.product-addons__checkbox'));
    var button = container.querySelector('[data-product-addons-atc]');

    checkboxes.forEach(function(checkbox) {
      updateCardState(checkbox);
      checkbox.addEventListener('change', function() {
        updateCardState(checkbox);
        updateSubtotal(container);
        updateButtonVisibility(container);
        setError(container, '');
      });
    });

    var quantityInput = getRelatedInput(container, 'quantity');
    if (quantityInput) {
      quantityInput.addEventListener('input', function() {
        updateSubtotal(container);
      });
      quantityInput.addEventListener('change', function() {
        updateSubtotal(container);
      });
    }

    if (button) {
      button.addEventListener('click', function() {
        handleAdd(container, button);
      });
    }

    setError(container, '');
    updateSubtotal(container);
    updateButtonVisibility(container);
  }

  function initAll(root) {
    root = root || document;
    if (root.matches && root.matches('[data-product-addons]')) {
      init(root);
    }
    toArray(root.querySelectorAll ? root.querySelectorAll('[data-product-addons]') : []).forEach(init);
  }

  function observeDynamicAddons() {
    if (!window.MutationObserver) return;
    var observerRoot = document.body || document.documentElement;
    if (!observerRoot) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        toArray(mutation.addedNodes).forEach(function(addedNode) {
          if (!addedNode || addedNode.nodeType !== 1) return;
          initAll(addedNode);
        });
      });
    });

    observer.observe(observerRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  observeDynamicAddons();
})();
